import classNames from 'classnames';
import {ChangeEvent, FC, useCallback} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';

import styles from './Checkbox.module.css';

export enum CheckboxSize {
    S = 'S',
    M = 'M',
    L = 'L',
}

const SIZE_CLASS_NAMES = {
    [CheckboxSize.S]: styles.sizeS,
    [CheckboxSize.M]: styles.sizeM,
    [CheckboxSize.L]: styles.sizeL,
};

type Props = {
    size?: CheckboxSize;
    className?: string;
    checked: boolean;
    name: string;
    label?: string;
    onCheck: (checked: boolean) => void;
};
export const Checkbox: FC<Props> = ({
    size = CheckboxSize.S,
    className,
    checked,
    name,
    label,
    onCheck,
}) => {
    const handleCheck = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            onCheck(event.target.checked);
        },
        [onCheck],
    );

    return (
        <div
            className={classNames(styles.block, className, {
                [styles.active]: checked,
            })}
        >
            <div
                className={classNames(styles.checkbox, SIZE_CLASS_NAMES[size])}
            >
                <input
                    type="checkbox"
                    id={name}
                    className={styles.input}
                    onChange={handleCheck}
                    checked={checked}
                />
                <Icon name="success" className={styles.icon} />
            </div>
            {label && (
                <Text.Bold14 className={styles.label}>
                    <label htmlFor={name}>{label}</label>
                </Text.Bold14>
            )}
        </div>
    );
};
